<template>
    <div class="form-group">
        <FormLabel>{{ label }}</FormLabel>
        <p>{{ value }}</p>
    </div>
</template>

<script>
import FormLabel from "./FormLabel";

export default {
    name: "FormConfirm",
    components: {FormLabel},
    props: {
        label: {
            type: String,
        },
        value: {
            type: String | Number,
        }
    }
}
</script>

<style scoped>

</style>
